<script>
export default {
  name: "SingleProductWrapper",
  props: {
    productLink: {
      default: null,
    },
  },
  data() {
    return {
      product: {}
    }
  },
  methods: {},
  render() {
    return this.$scopedSlots.default({
      product: this.product.data !== undefined ? this.product.data.data : [],
    });
  },
  async mounted() {

    if (this.productLink == null) {
      this.product = await this.$store.dispatch("Product/getProductWithoutState", this.$route.params.name)
    } else {
      this.product = await this.$store.dispatch("Product/getProductWithoutState", this.productLink)
    }

    this.$emit('product', this.product.data.data)

  },
  watch: {
    $route: {
      async handler() {
        this.product = await this.$store.dispatch("Product/getProductWithoutState", this.$route.params.name)
        await this.$emit('product', this.product.data.data)
      },
    },
  },
}
</script>
